export default {"src":"/_next/static/media/GPK.38f9dab7.svg","height":18,"width":18};